import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content" style={{ overflowY: "inherit" }}>
                <section className="bg-sky-blue wide-tb-100 pb-0">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>What We Offer</span>
                                    Our Core Services
                                </h1>
                            </div>
                            <div className="col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <a href="service-details.html">
                                    <div className="icon-box-4 h-100">
                                        <i className="icofont-airplane-alt"></i>
                                        <h4 className="h4-md mb-3">Packaging and Storage</h4>
                                        <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.4s">
                                <a href="service-details.html">
                                    <div className="icon-box-4 h-100">
                                        <i className="icofont-fire-truck"></i>
                                        <h4 className="h4-md mb-3">Truck Freight</h4>
                                        <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.6s">
                                <a href="service-details.html">
                                    <div className="icon-box-4 h-100">
                                        <i className="icofont-ship"></i>
                                        <h4 className="h4-md mb-3">Ocean Freight</h4>
                                        <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                    </div>
                                </a>
                            </div>
                            <div className="text-center btn-center mx-auto">
                                <a href="#" className="btn-theme bg-primary">Request Quote <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="bg-white wide-tb-100 bg-wave">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="img-business-man">
                                <img src="images/business-man.png" alt="" />
                            </div>
                            <div className="col-sm-12">
                                <h1 className="heading-main wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                    <span>Our Goodness</span>
                                    What Makes Us Special
                                </h1>
                            </div>
                            <div className="col-md-8 ml-auto why-choose wow fadeInRight" data-wow-duration="0" data-wow-delay="0.6s">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-id"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Trusted Franchise</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-live-support"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Customer Support</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 spacer-60 d-none d-md-none d-lg-block d-sm-none"></div>
                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-history"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Reliability & Punctuality</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="icon-box-2">
                                            <div className="media">
                                                <div className="service-icon">
                                                    <i className="icofont-briefcase-1"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Consulting Services</h4>
                                                    <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 text-center">
                                    <div className="spacer-50">
                                    </div>
                                    <a href="#" className="btn-theme bg-primary">Request Quote <i className="icofont-rounded-right"></i></a>
                                    <div className="spacer-30">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 bg-fixed pos-rel tracking parallax">
                    <div className="bg-overlay black opacity-60"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 offset-md-3">
                                <h1 className="heading-main parallax-head wow fadeInDown" data-wow-duration="0" data-wow-delay="0">
                                    <span>get updates</span>
                                    Tracking Your Freight
                                </h1>
                                <form className="form-inline wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2">
                                    <input type="text" className="form-control mb-2 mr-sm-2 col" placeholder="Enter order number" />
                                    <button type="submit" className="btn btn-theme bg-white mb-2 ml-3 bordered">Check Now <i className="icofont-rounded-right"></i></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0 team-section-bottom pos-rel">
                    <div className="container">
                        <div className="col-sm-12">
                            <h1 className="heading-main">
                                <span>Face Behind Logzee</span>
                                Our Team
                            </h1>
                        </div>
                        <div className="row pb-4">
                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0s">
                                <div className="team-section-two">
                                    <img src="images/team/team-1.jpg" alt="" className="rounded" />
                                    <h4 className="h4-md txt-orange">John Morise</h4>
                                    <h5 className="h5-md txt-ligt-gray">Founder</h5>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="team-section-two">
                                    <img src="images/team/team-2.jpg" alt="" className="rounded" />
                                    <h4 className="h4-md txt-orange">Kevin Mash</h4>
                                    <h5 className="h5-md txt-ligt-gray">Head Operational</h5>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="team-section-two">
                                    <img src="images/team/team-3.jpg" alt="" className="rounded" />
                                    <h4 className="h4-md txt-orange">Mike Douglos</h4>
                                    <h5 className="h5-md txt-ligt-gray">Team Lead Support</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="bg-white wide-tb-100 mb-spacer-md">
                    <div className="container">
                        <div className="col-sm-12">
                            <h1 className="heading-main">
                                <span>Request a </span>
                                Free Quote
                            </h1>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 wow fadeInRight" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="align-self-stretch h-100 align-items-center d-flex bg-with-text">
                                    Whether you require distribution or fulfillment, defined freight forwarding, or a complete supply chain solution, we are here for you.
                                </div>
                            </div>
                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>
                            <div className="col-lg-8 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0.2s">
                                <form action="#" method="post" noValidate="novalidate" className="rounded-field gray-field">
                                    <div className="form-row mb-4">
                                        <div className="col">
                                            <input type="text" name="name" className="form-control" placeholder="Your Name" />
                                        </div>
                                        <div className="col">
                                            <input type="text" name="email" className="form-control" placeholder="Email" />
                                        </div>
                                    </div>
                                    <div className="form-row mb-4">
                                        <div className="col">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Transport Type</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="col">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Type of freight</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-row mb-4">
                                        <div className="col">
                                            <textarea rows="7" placeholder="Message" className="form-control"></textarea>
                                        </div>
                                    </div>
                                    <div className="form-row text-center">
                                        <button type="submit" className="form-btn mx-auto btn-theme bg-secondary">Request Quote <i className="icofont-rounded-right"></i></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-60 p-0">
                    <div className="container wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1">
                                <div className="bg-scroll client-testimonials-bg pos-rel rounded">
                                    <div className="bg-overlay blue opacity-80"></div>
                                    <div className="owl-carousel owl-theme" id="client-testimonials-bg">
                                        <div className="item">
                                            <div className="client-testimonial">
                                                <div className="client-testimonial-icon rounded-circle bg-primary mx-auto mb-4">
                                                    <img src="images/team_1.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="client-testimonial">
                                                <div className="client-testimonial-icon rounded-circle bg-primary mx-auto mb-4">
                                                    <img src="images/team_2.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="client-testimonial">
                                                <div className="client-testimonial-icon rounded-circle bg-primary mx-auto mb-4">
                                                    <img src="images/team_3.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0 mb-spacer-md">
                    <div className="container">
                        <div className="row d-flex align-items-center">
                            <div className="col col-12 col-lg-3 col-sm-6 wow pulse" data-wow-duration="0" data-wow-delay="0s">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-google-map"></i></p>
                                    <span className="counter">15</span>
                                    <div>
                                        Our Locations
                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 col-lg-3 col-sm-6 wow pulse" data-wow-duration="0" data-wow-delay="0.3s">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-globe"></i></p>
                                    <span className="counter">110</span>
                                    <span>+</span>
                                    <div>
                                        Clients Worldwide
                                    </div>
                                </div>
                            </div>
                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>
                            <div className="col col-12 col-lg-3 col-sm-6 wow pulse" data-wow-duration="0" data-wow-delay="0.6s">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-vehicle-delivery-van"></i></p>
                                    <span className="counter">240</span>
                                    <span>+</span>
                                    <div>
                                        Owned Vehicles
                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 col-lg-3 col-sm-6 wow pulse" data-wow-duration="0" data-wow-delay="0.9s">
                                <div className="counter-style-1 light-bg">
                                    <p className="mb-1"><i className="icofont-umbrella-alt"></i></p>
                                    <span className="counter">2340</span>
                                    <div>
                                        Tonnes Transported
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h1 className="heading-main">
                                    <span>COMPANY'S NEWS</span>
                                    Recent Posts
                                </h1>
                            </div>
                            <div className="col-sm-12 col-md-4 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_1.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_2.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 wow fadeInRight" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_3.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-80 bg-scroll bg-img-6 pos-rel callout-style-1">
                    <div className="bg-overlay blue opacity-60"></div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0 wow slideInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col wow slideInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
                                </div>
                            </div>
                            <div className="col-sm-auto wow slideInUp" data-wow-duration="0" data-wow-delay="0.3s">
                                <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="twitter-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3">
                                <div className="twitter-feed d-flex align-items-center rounded-bottom">
                                    <i className="icofont-twitter icon-feed txt-orange"></i>
                                    <div className="tweet-stream"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow slideInDown" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="owl-carousel owl-theme" id="home-clients">
                                    <div className="item bg-sky-blue">
                                        <img src="images/clients/client1.png" alt="" />
                                    </div>
                                    <div className="item bg-sky-blue">
                                        <img src="images/clients/client2.png" alt="" />
                                    </div>
                                    <div className="item bg-sky-blue">
                                        <img src="images/clients/client3.png" alt="" />
                                    </div>
                                    <div className="item bg-sky-blue">
                                        <img src="images/clients/client4.png" alt="" />
                                    </div>
                                    <div className="item bg-sky-blue">
                                        <img src="images/clients/client5.png" alt="" />
                                    </div>
                                    <div className="item bg-sky-blue">
                                        <img src="images/clients/client6.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container">
                        <div className="row d-flex">
                            <div className="col-lg-6 col-sm-12 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0.1s">
                                <h4 className="h4-md mb-4 txt-orange">Find us at the office</h4>
                                <div className="contact-details standard row pos-rel d-inline-flex">
                                    <div className="col">
                                        <h4>Germany</h4>
                                        <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                                        <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">germany@logzee.com</a></div>
                                    </div>
                                    <div className="col">
                                        <h4>Spain</h4>
                                        <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                                        <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">spain@logzee.com</a></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <section className="map-bg map-shadow">
                                    <div id="map-holder" className="pos-rel">
                                        <div id="map_extended">
                                            <p>This will be replaced with the Google Map.</p>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default Content;
